import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';

const API_URL = `${process.env.REACT_APP_VENDOR_DOMAIN}/api/service_details`;

export default function ServiceDetails() {
  const { id } = useParams();
  const [serviceDetails, setServiceDetails] = useState([]);
  const [editIdx, setEditIdx] = useState(null);
  const [editData, setEditData] = useState({});
  const [newDetail, setNewDetail] = useState({ title: '', description: '', image_url: '' });

  // Fetch service details
  useEffect(() => {
    fetchDetails();
    // eslint-disable-next-line
  }, [id]);

  const fetchDetails = () => {
    axios
      .get(`${API_URL}/${id}`)
      .then((res) => {
        const data = Array.isArray(res.data) ? res.data : [res.data];
        setServiceDetails(data);
      })
      .catch((err) => console.error('Error fetching service:', err));
  };

  // Create
  const handleCreate = () => {
    axios
      .post(API_URL, { service_id: id, ...newDetail })
      .then(() => {
        setNewDetail({ title: '', description: '', image_url: '' });
        fetchDetails();
      })
      .catch((err) => alert('Error creating detail'));
  };

  // Edit
  const handleEdit = (idx) => {
    setEditIdx(idx);
    setEditData({ ...serviceDetails[idx] });
  };

  // Update
  const handleUpdate = (detailId) => {
    axios
      .put(`${API_URL}/${detailId}`, editData)
      .then(() => {
        setEditIdx(null);
        setEditData({});
        fetchDetails();
      })
      .catch((err) => alert('Error updating detail'));
  };

  // Delete
  const handleDelete = (detailId) => {
    if (window.confirm('Are you sure you want to delete this detail?')) {
      axios
        .delete(`${API_URL}/${detailId}`)
        .then(() => fetchDetails())
        .catch((err) => alert('Error deleting detail'));
    }
  };

  if (!serviceDetails.length) {
    return (
      <div className="container my-5 text-center">
        <p>Loading service details...</p>
      </div>
    );
  }

  return (
    <div className="container my-5">
      <Link to="/services" className="btn btn-outline-secondary mb-4">
        ← Back to Services
      </Link>

      {/* Create new detail */}
      <div className="card mb-4" style={{ borderRadius: '12px' }}>
        <div className="card-body">
          <h5 className="card-title" style={{ color: '#4078c0' }}>Add Service Detail</h5>
          <div className="row g-2">
            <div className="col-md">
              <input
                type="text"
                placeholder="Name"
                value={newDetail.title}
                onChange={e => setNewDetail({ ...newDetail, name: e.target.value })}
                className="form-control"
              />
            </div>
            <div className="col-md">
              <input
                type="text"
                placeholder="Description"
                value={newDetail.description}
                onChange={e => setNewDetail({ ...newDetail, description: e.target.value })}
                className="form-control"
              />
            </div>
            <div className="col-md">
              <input
                type="text"
                placeholder="Image URL"
                value={newDetail.image_url}
                onChange={e => setNewDetail({ ...newDetail, image_url: e.target.value })}
                className="form-control"
              />
            </div>
            <div className="col-md-auto">
              <button onClick={handleCreate} className="btn btn-primary w-100">Add</button>
            </div>
          </div>
        </div>
      </div>

      {/* List and edit details */}
      {serviceDetails.map((service, idx) => (
        <div className="card shadow-lg mb-5" key={service.id || idx} style={{ borderRadius: '16px', overflow: 'hidden' }}>
          {editIdx === idx ? (
            <div className="card-body" style={{ padding: '32px 24px' }}>
              <input
                className="form-control mb-2"
                value={editData.name}
                onChange={e => setEditData({ ...editData, name: e.target.value })}
                placeholder="Title"
              />
              <textarea
                className="form-control mb-2"
                value={editData.description}
                onChange={e => setEditData({ ...editData, description: e.target.value })}
                placeholder="Description"
              />
              <input
                className="form-control mb-2"
                value={editData.image_url}
                onChange={e => setEditData({ ...editData, image_url: e.target.value })}
                placeholder="Image URL"
              />
              <div className="d-flex gap-2 mt-2">
                <button className="btn btn-success btn-sm" onClick={() => handleUpdate(service.id)}>Save</button>
                <button className="btn btn-secondary btn-sm" onClick={() => setEditIdx(null)}>Cancel</button>
              </div>
            </div>
          ) : (
            <>
              {service.image_url && (
                <div style={{ background: '#f5f6fa', padding: '24px 24px 0 24px' }}>
                  <img
                    src={service.image_url}
                    alt={service.name}
                    className="img-fluid"
                    style={{
                      maxHeight: '260px',
                      objectFit: 'cover',
                      borderRadius: '12px',
                      display: 'block',
                      margin: '0 auto',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                    }}
                  />
                </div>
              )}
              <div className="card-body" style={{ padding: '32px 24px' }}>
                <h3 className="card-title" style={{ color: '#4078c0', fontWeight: 700, fontSize: '2rem', marginBottom: '16px' }}>
                  {service.name}
                </h3>
                <p className="card-text" style={{ fontSize: '1.15rem', color: '#333', marginBottom: '18px' }}>
                  {service.description}
                </p>
                <div className="d-flex flex-wrap gap-3 mt-3">
                  {service.creation_date && (
                    <span className="card-text text-muted" style={{ fontSize: '0.95rem' }}>
                      <strong>Created:</strong> {new Date(service.creation_date).toLocaleString()}
                    </span>
                  )}
                  {service.modification_date && (
                    <span className="card-text text-muted" style={{ fontSize: '0.95rem' }}>
                      <strong>Last Modified:</strong> {new Date(service.modification_date).toLocaleString()}
                    </span>
                  )}
                </div>
                <div className="d-flex gap-2 mt-3">
                  <button className="btn btn-warning btn-sm text-white" onClick={() => handleEdit(idx)}>Edit</button>
                  <button className="btn btn-danger btn-sm" onClick={() => handleDelete(service.id)}>Delete</button>
                </div>
              </div>
            </>
          )}
        </div>
      ))}
    </div>
  );
}